const userTypes = {
    REGISTER_ACTION: "REGISTER_ACTION",
    LOGIN_ACTION: "LOGIN_ACTION",
    LOGOUT_ACTION: "LOGOUT_ACTION",
    CHECK_USER_ACTION: "CHECK_USER_ACTION",
    REGISTER_SUCCESS: "REGISTER_SUCCESS",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    CHECK_USER_SUCCESS: "CHECK_USER_SUCCESS",
    REGISTER_FAIL: "REGISTER_FAIL",
    LOGIN_FAIL: "LOGIN_FAIL",
    LOGOUT_FAILED: "LOGOUT_FAILED",
    CHECK_USER_FAILED: "CHECK_USER_FAILED"
}

export default userTypes;